import React, {useState, useEffect, useCallback} from 'react';
import {Input, Button, Image, message, Space} from 'antd'
import {useParams, useNavigate} from 'react-router-dom'
import AvatarUploader from '../../components/Uploader'
import Api from '../../api'
import {emptyValidate} from '../../util/validate'

const {TextArea} = Input;

export default function () {
    const navigate = useNavigate();
    const params = useParams();

    const [lecturerName, setLecturerName] = useState()
    const [headImg, setHeadImg] = useState()
    const [title, setTitle] = useState()
    const [introduce, setIntroduce] = useState()

    useEffect(() => {
        if (params.id) {
            Api.getLecturerInfo(params.id).then(resp => {
                let info = resp.info;
                setLecturerName(info.lecturerName)
                setTitle(info.title)
                setHeadImg(info.headImg)
                setIntroduce(info.introduce)
            })
        } else {
            setLecturerName()
            setHeadImg()
            setTitle()
            setIntroduce()
        }
    }, [params.id])


    const save = useCallback(() => {
        let data = {
            lecturerName,
            headImg,
            title,
            introduce
        }

        let validateResult = emptyValidate(lecturerName, '请填写讲师昵称')
            || emptyValidate(headImg, '请上传讲师头像')
            || emptyValidate(title, '请填写讲师头衔')
            || emptyValidate(introduce, '请填写讲师介绍');

        if (validateResult) {
            return;
        }


        if (params.id) {
            data.lecturerId = params.id
        }
        Api.createUpdateLecturer(data).then(resp => {
            if (resp.resultCode === 1) {
                message.success(resp.resultMessage)
                if (params.id) {
                    navigate(-1)
                } else {
                    navigate('/teacher/list')
                }
            }
        })
    })

    const cancel = useCallback((url) => {
        if (params.id) {
            navigate(-1)
        } else {
            navigate('/teacher/list')
        }
    })

    const onUpload = useCallback((url) => {
        setHeadImg(url)
    })


    return <div className="white-bg pdv40 pdh32 mgv12" style={{minWidth:800, maxWidth: 1200}}>
        <div className="flexbox">
            <div className="pd12" style={{width: '400px'}}>
                <div className="required bold">讲师昵称</div>
                <div className="mgb20 pdv12">
                    <Input
                        value={lecturerName}
                        onChange={e => setLecturerName(e.target.value)}
                        maxLength={40}
                        placeholder="请输入讲师昵称"/>
                </div>

                <div className="required bold">讲师头像：</div>
                <div className="pdv12">
                    <AvatarUploader onResult={onUpload}>
                        {headImg && <Image src={headImg} preview={false} style={{width: 100, height: 100}}/>}
                    </AvatarUploader>
                    <div>支持jpg、png、jpeg格式，尺寸为600px *600px</div>
                </div>
            </div>
            <div className="flex1 pd12">
                <div className="required bold">讲师头衔</div>
                <div className="mgb20  pdv12">
                    <Input
                        value={title}
                        maxLength={80}
                        onChange={e => setTitle(e.target.value)}
                        placeholder="请填写"/>
                </div>
                <div className="required bold">讲师介绍</div>
                <div className="pdv12">
                    <TextArea
                        placeholder="请填写"
                        value={introduce}
                        onChange={e => setIntroduce(e.target.value)}
                        showCount
                        maxLength={500}
                        style={{height: 120, resize: 'none'}}
                    ></TextArea>
                </div>
            </div>
        </div>
        <div className="text-right mgt30">
            <Space>
                <Button onClick={cancel}>取消</Button>
                <Button type="primary" onClick={save}>保存</Button>
            </Space>
        </div>
    </div>
}
